import { Route, Routes as RouterRoutes } from 'react-router-dom';

import { Error404Page } from '../error/404Page';
import { Page as VisitorSessionPage } from './Page';
import { Page as NoShowPage } from './no-show-confirmation-page';

export function Routes() {
  return (
    <RouterRoutes>
      <Route index element={<VisitorSessionPage />} />
      <Route path='/no-show' element={<NoShowPage />} />
      <Route path='*' element={<Error404Page />} />
    </RouterRoutes>
  );
}
